import { TileLayer } from 'react-leaflet';

// Camada de tiles padrão do OpenStreetMap (mesmo visual do openstreetmap.org).
// Um único lugar para TODOS os mapas do web — trocar o estilo aqui reflete em todos.
export default function OsmTiles() {
  return (
    // `updateWhenIdle` importa AQUI, não no app: no desktop o padrão do Leaflet é `false`, então cada
    // frame de arrasto pede tiles novos. No mobile o padrão já é `true` (o Leaflet detecta touch).
    // `keepBuffer` guarda uma faixa a mais fora da tela, para pan curto não rebuscar o que já saiu.
    // É servidor público da OSMF em uso comercial — reduzir pedido é o que mantém o acesso.
    <TileLayer
      url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      maxZoom={19}
      keepBuffer={3}
      updateWhenIdle
    />
  );
}
